/**
 * Hook that checks if the current user has permission to access a section.
 * Returns { hasPermission, isLoading } for the given permission key.
 */
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/_core/hooks/useAuth";
import type { PermissionKey } from "@shared/permissions";

export function usePermissions() {
  const { user, isAuthenticated } = useAuth();
  const { data: permissions, isLoading } = trpc.teamAccess.myPermissions.useQuery(
    undefined,
    { enabled: isAuthenticated }
  );

  function hasPermission(key: PermissionKey): boolean {
    // Admin always has full access
    if (user?.role === "admin") return true;
    if (!permissions) return false;
    return permissions[key] === true;
  }

  return { hasPermission, isLoading, permissions };
}
